module.exports = __webpack_public_path__ + "static/media/dashboard-icon-themes.e2a3b3eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dashboard-icon-themes.svg
// module id = 743
// module chunks = 0